import { propertyDraftQueryKeys as e } from "./propertyDraftQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { propertyDraftsApi as n } from "@maat/api-main";
//#region src/propertyDrafts/usePropertyDraftDetailQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getDraft(r),
	enabled: !!r
});
//#endregion
export { r as usePropertyDraftDetailQuery };
